import ReactMarkdown from 'react-markdown';

export const Feedback = ({ feedback }) => {
  return (
      <ReactMarkdown className="prose">{feedback}</ReactMarkdown>

  );
};



